var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"px-4 pt-4"},[_c('h1',{staticClass:"mb-4"},[_vm._v("\n    "+_vm._s(_vm.$t('Profiles'))+"\n  ")]),_c('user-list',{attrs:{"data-source":_vm.dataSource,"local-storage":"users-grid-storage"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }